// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"317":"124e8b93","679":"86aada39","713":"f4d2852d","979":"bb9bd9e8"}[chunkId] + ".css";
};